export default "__VITE_ASSET__r3C_xKBk__"